<template>
    <v-dialog v-model="dialog" width="450">
        <template v-slot:activator="{ on, attrs }">
            <v-list-item v-bind="attrs" v-on="on" link class="pr-0 pl-12">
                <v-list-item-content class="py-0">
                    <v-list-item-title>Выверка</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
        <v-card class="dialogBackground">
            <v-row no-gutters class="dialogTitleBackground white--text px-2 py-1 mb-2" align="center">
                <span>Выверка</span>
                <v-spacer />
                <v-btn small icon dark @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-row>

            <v-card-text>
                <v-row dense>
                    <span>Выберите период, за который должен быть сформирована выверка</span>
                </v-row>
                <v-row dense class="mt-8">
                    <v-col>
                        <PeriodSelector v-model="period" dense
                            :error-messages="objectErrors(this.$v.period.dateFrom).concat(objectErrors(this.$v.period.dateTo))"
                            @input="$v.period.dateFrom.$touch(); $v.period.dateTo.$touch()"
                            @blur="$v.period.dateFrom.$touch(); $v.period.dateTo.$touch()" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn class="px-12" color="primary" :loading="loading" @click.prevent="okClick">
                    ОК
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import PeriodSelector from "@/components/PeriodSelector"
import { required } from "vuelidate/lib/validators"

export default {
    components: {
        PeriodSelector
    },

    data: () => ({
        dialog: false,
        period: { dateFrom: null, dateTo: null },
        fileType: "pdf",
        loading: false
    }),

    watch: {
        dialog(val) {
            this.$v.$reset()
            if (val) {
                this.setDefaultPeriod()
            }
        }
    },

    validations() {
        return {
            period: { dateFrom: { required }, dateTo: { required } },
        }
    },

    methods: {
        objectErrors(obj) {
            if (!obj.$dirty) return []
            const errors = []

            obj.$params.required && !obj.required && errors.push("Задайте период")
            return errors
        },

        formatDateToString(date) {
            // Форматируем дату в YYYY-MM-DD для PeriodSelector
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },

        setDefaultPeriod() {
            const today = new Date()
            const currentYear = today.getFullYear()
            const currentMonth = today.getMonth()
            const currentDay = today.getDate()

            let dateFrom, dateTo

            if (currentDay === 1) {
                // Если сегодня 1 число месяца
                // dateFrom - 1 число прошлого месяца
                dateFrom = new Date(currentYear, currentMonth - 1, 1)
                // dateTo - последнее число прошлого месяца
                dateTo = new Date(currentYear, currentMonth, 0)
            } else {
                // Если сегодня не 1 число
                // dateFrom - 1 число текущего месяца
                dateFrom = new Date(currentYear, currentMonth, 1)
                // dateTo - вчерашний день
                dateTo = new Date(currentYear, currentMonth, currentDay - 1)
            }

            // Сохраняем как строки в формате YYYY-MM-DD
            this.period.dateFrom = this.formatDateToString(dateFrom)
            this.period.dateTo = this.formatDateToString(dateTo)
        },

        async okClick() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }

            try {
                this.loading = true;

                const params = {
                    dateFrom: this.period.dateFrom,
                    dateTo: this.period.dateTo
                };

                this.$router.push({
                    path: '/reports/VerificationResultsDisplaying',
                    query: params
                });

                this.loading = false
                this.dialog = false

            } catch (err) {
                this.$notify(
                    "error",
                    err.response?.data?.message ? err.response.data.message : "Ошибка при формировании выверки"
                )
            } finally {
                this.loading = false
            }
        }
    }
}
</script>